import {CopilotIcon} from '@primer/octicons-react'
import {useSuspenseActivityPageData} from '../../data/use-activity-page-data'
import {SidebarActivityRow} from './SidebarActivityRow'
import {hasCopilotActivity, pluralize} from './activity-row-helpers'

// Cross-cutting with the other rows (the same event can also appear under
// Approvals, Commits, etc.) — it surfaces everything Copilot did, regardless
// of category, and opens the timeline scoped to `actor:copilot`.
export function CopilotEventsRow() {
  const {summary} = useSuspenseActivityPageData()
  if (!hasCopilotActivity(summary)) return null

  const n = summary?.copilotActivity?.count ?? 0
  const label = `${n} Copilot ${pluralize(n, 'event', 'events')}`

  return (
    <SidebarActivityRow
      icon={CopilotIcon}
      categoryLabel="Copilot events"
      label={label}
      group="copilotActivity"
      expectedCount={n}
    />
  )
}
